export enum NavigationMenuPopupCssVars {
  /**
   * The fixed width of the popup element.
   * @type {number}
   */
  popupWidth = '--popup-width',
  /**
   * The fixed height of the popup element.
   * @type {number}
   */
  popupHeight = '--popup-height',
}
